'use client';

import { c as _c } from "react/compiler-runtime";
import { Tag } from '@eversports/klimt-primitives/Tag';
import { useTranslations } from 'next-intl';
import type { LimitedSpots, UnlimitedSpots } from '../../../../../../../../App.types';
import { EventRegistrationValidationProblem, type RegistrationState } from '../../ActivityCard.types';
interface Props {
  registrationState: RegistrationState;
  availableSpots: Omit<LimitedSpots, 'type'> | Omit<UnlimitedSpots, 'type'>;
}
const RegistrationStateBadges = t0 => {
  const $ = _c(20);
  const {
    registrationState,
    availableSpots
  } = t0;
  const t = useTranslations("discover-sport-city");
  const {
    bookable,
    validationProblems
  } = registrationState;
  const {
    __typename
  } = availableSpots;
  let t1;
  if ($[0] !== bookable || $[1] !== validationProblems) {
    t1 = !bookable && validationProblems.includes(EventRegistrationValidationProblem.ALREADY_REGISTERED);
    $[0] = bookable;
    $[1] = validationProblems;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const hasBooked = t1;
  let t2;
  if ($[3] !== bookable || $[4] !== validationProblems) {
    t2 = !bookable && validationProblems.includes(EventRegistrationValidationProblem.FULLY_BOOKED);
    $[3] = bookable;
    $[4] = validationProblems;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const isSoldOut = t2;
  const showBookingUrgency = __typename === "LimitedSpots" && availableSpots.limit > 0 && !availableSpots.displayCapped;
  const spotsLeft = __typename === "LimitedSpots" && availableSpots.limit;
  if (!hasBooked && !isSoldOut && !showBookingUrgency) {
    return null;
  }
  let t3;
  if ($[6] !== hasBooked || $[7] !== t) {
    t3 = hasBooked && <Tag variant="primary" style="outline" text={t("registration-state-already-registered")} />;
    $[6] = hasBooked;
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== showBookingUrgency || $[10] !== spotsLeft || $[11] !== t) {
    t4 = showBookingUrgency && spotsLeft && <Tag variant="tertiary" style="outline" text={t("registration-state-spots-left", {
      count: spotsLeft
    })} />;
    $[9] = showBookingUrgency;
    $[10] = spotsLeft;
    $[11] = t;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== isSoldOut || $[14] !== t) {
    t5 = isSoldOut && <Tag variant="warning" style="outline" text={t("registration-state-spots-left", {
      count: 0
    })} />;
    $[13] = isSoldOut;
    $[14] = t;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t3 || $[17] !== t4 || $[18] !== t5) {
    t6 = <>{t3}{t4}{t5}</>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
};
export default RegistrationStateBadges;